module.exports = __webpack_public_path__ + "static/media/class_02.b3bae6fe.jpg";